import { inject, Injectable, Injector, runInInjectionContext } from '@angular/core';
import { Database, DataSnapshot, get, ref } from '@angular/fire/database';
import { Crisp } from 'crisp-sdk-web';
import { AuthenticatedUser, DashboardOwnerUser } from '@dashboard_models/dashboard-owner-user';
import { HelperService } from '../helper/helper.service';
import { ShallowAccountDetails } from '@airwallet/shared-models/billing/shallow-account-details';
import { LocalStorageService } from '@services/local-storage/local-storage.service';

interface CrispDataObj {
    business_type?: string;
    account_id?: string;
    customer_uid?: string;
    stripe_link?: string;
    db_link?: string;
    [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class ChatbotService {
    authenticatedUser: AuthenticatedUser;
    private database: Database = inject(Database);
    private injector: Injector = inject(Injector);
    private localStorageService: LocalStorageService = inject(LocalStorageService);
    async setupChatBot(): Promise<void> {
        this.authenticatedUser = this.localStorageService.getItem('authenticatedUser');
        if (!this.authenticatedUser) {
            return;
        }

        // const snap: SnapshotAction<ShallowAccountDetails> = (await lastValueFrom(this.database.object(`customers/${this.user.uid}/billing/shallow_account_details`).snapshotChanges().pipe(take(1)))) as SnapshotAction<ShallowAccountDetails>;

        runInInjectionContext(this.injector, async () => {
            const dbRef = ref(this.database, `customers/${this.authenticatedUser.uid}/billing/shallow_account_details`);
            const snapshot: DataSnapshot = await get(dbRef);
            const _obj: CrispDataObj = {};
            if (snapshot.exists() && snapshot.val() !== null) {
                const data: ShallowAccountDetails = snapshot.val() as ShallowAccountDetails;
                if (data.name && typeof data.name === 'string') {
                    Crisp.user.setNickname(data.name);
                }
                _obj.business_type = data.business_type;
                _obj.account_id = data.account_id;
                _obj.customer_uid = this.authenticatedUser.uid;
                _obj.stripe_link = `https://dashboard.stripe.com/connect/accounts/${data.account_id}/activity`;
                _obj.db_link = `https://console.firebase.google.com/u/0/project/airwallet-685ff/database/airwallet-685ff/data/~2Fcustomers~2F${this.authenticatedUser.uid}`;
                Crisp.session.setData(_obj);
            } else {
                Crisp.session.setData({ customer_uid: this.authenticatedUser.uid });
            }
            Crisp.user.setEmail(this.authenticatedUser.email);
        });
    }
}
